import React from "react";

export default function WorliMataka() {
    return (
        <div className="modal-dialog modal-xl">
            <div className="modal-content">
                <div className="modal-header">
                    <div className="modal-title h4">Result</div>
                    <button type="button" className="btn-close" aria-label="Close" />
                </div>
                <div className="modal-body">
                    <div className="casino-result-modal">
                        <div className="casino-result-round-id">
                            <span>
                                <b>Round Id: </b> 126250517142242
                            </span>
                            <span>
                                <b>Match Time: </b>17/05/2025 14:24:14
                            </span>
                        </div>
                        <div className="row mt-2">
                            <div className="col-md-12 text-center">
                                <div className="casino-result-cards">
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/undefined.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/undefined.jpg" />
                                    <img src="https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/undefined.jpg" />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-2 justify-content-center">
                            <div className="col-md-6">
                                <div className="casino-result-desc">
                                    <div className="casino-result-desc-item">
                                        <div>Pana</div>
                                        <div />
                                    </div>
                                    <div className="casino-result-desc-item">
                                        <div>Ocada</div>
                                        <div />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}
